import { Box, Typography } from '@/shared/ui';

import { useUserDetails } from '@/features/_shared/user';

import { FeedRow } from './components/FeedRow';
import { FeedSkeleton } from './components/FeedSkeleton';
import { useFeedData } from './queries/useFeedData';

import type { FeedFilters } from './api/fetchFeedData';

const FeedEmptyState = () => (
  <Box
    sx={{
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '160px',
      textAlign: 'center',
      color: 'text.secondary'
    }}
  >
    <Typography>No feed updates available.</Typography>
  </Box>
);

export const Feed = ({ metadata }: { metadata: FeedFilters }) => {
  const { isUserExpired } = useUserDetails();

  const { data, isLoading, isSuccess } = useFeedData(metadata);
  const hasNoData = isSuccess && data?.length === 0;

  return (
    <Box
      sx={{
        px: '8px',
        py: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        maxHeight: '650px',
        minHeight: '200px',
        overflowY: 'auto'
      }}
    >
      {isUserExpired ? (
        <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Typography sx={{ textAlign: 'center' }}>
            You no longer have access.
            <br />
            Please upgrade to access Feed.
          </Typography>
        </Box>
      ) : (
        <>
          {isLoading && <FeedSkeleton />}

          {hasNoData && <FeedEmptyState />}

          {data?.map(row => (
            <FeedRow
              key={row.transactionTime + row.values.Title}
              {...row}
            />
          ))}
        </>
      )}
    </Box>
  );
};
